import { render } from "./data-tables.vue?vue&type=template&id=92a93e1c"
import script from "./data-tables.vue?vue&type=script&lang=js"
export * from "./data-tables.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__